import { render, staticRenderFns } from "./DashboardModulesWrapper.vue?vue&type=template&id=2230f722&scoped=true"
import script from "./DashboardModulesWrapper.vue?vue&type=script&lang=js"
export * from "./DashboardModulesWrapper.vue?vue&type=script&lang=js"
import style0 from "./DashboardModulesWrapper.vue?vue&type=style&index=0&id=2230f722&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2230f722",
  null
  
)

export default component.exports